import React from "react";
import ParticlesBg from "particles-bg";

class Bg2 extends React.Component {
  constructor() {
    super();
    this.state = {
      name: "React"
    };
  }

  render() {


    return (
      <div>

        <ParticlesBg  type="polygon" bg={true} />
      </div>
    )
  }
}
export default Bg2;